import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
    UIButton
} from 'components/ui';

interface CardDropdownMenuProps {
    hasImage: boolean;
    onUploadClick: () => void;
    onRemoveClick: () => void;
}

export const CardDropdownMenu: React.FC<CardDropdownMenuProps> = ({
    hasImage,
    onUploadClick,
    onRemoveClick
}) => {
    return (
        <div className="absolute top-2 right-2 z-10">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <UIButton
                        variant="ghost"
                        size="sm"
                        className="w-8 h-8 p-0 bg-white/80 hover:bg-white shadow-sm opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100 transition-opacity rounded-[15px] focus:outline-none"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FontAwesomeIcon
                            icon="fa-solid fa-ellipsis-vertical"
                            className="w-3 h-3 text-gray-600"
                        />
                    </UIButton>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    align="end"
                    className="min-w-max bg-white border border-[#E4E4E7] rounded-md shadow-lg"
                >
                    <DropdownMenuItem
                        onClick={(e) => {
                            e.stopPropagation();
                            onUploadClick();
                        }}
                        className="cursor-pointer text-gray-600 hover:bg-gray-100 hover:text-black whitespace-nowrap"
                    >
                        Upload image thumbnail
                    </DropdownMenuItem>
                    {hasImage && (
                        <DropdownMenuItem
                            onClick={(e) => {
                                e.stopPropagation();
                                onRemoveClick();
                            }}
                            className="cursor-pointer text-gray-600 hover:bg-gray-100 hover:text-black whitespace-nowrap"
                        >
                            Remove image thumbnail
                        </DropdownMenuItem>
                    )}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

